import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

export default function Testimonials() {
  return (
    <section className="py-5 bg-light" id="testimonials">
      <div className="container">
        <div className="row mb-5 align-items-center">
          <div className="col-lg-4">
            <h2 className="display-6 fw-bold" style={{ color: '#1cc3b2' }}>Testimonials</h2>
          </div>
          <div className="col-lg-8">
            <p className="text-muted mb-0">
            
            </p>
          </div>
        </div>

        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          breakpoints={{
            992: { slidesPerView: 3 }
          }}
          className="pb-5"
        >
          {[1, 2, 3].map((i) => (
            <SwiperSlide key={i}>
              <div className="card border-0 p-4 shadow-sm h-100 position-relative">
                {/* Floating Quote Icon */}
                <div 
                  className="d-flex align-items-center justify-content-center shadow-sm mb-4"
                  style={{ width: '40px', height: '40px', backgroundColor: '#1cc3b2', borderRadius: '4px' }}
                >
                  <i className="bi bi-quote text-white fs-4"></i>
                </div>
                
                <p className="text-muted fst-italic mb-4">
                  "Had amazing experience with Nivara Agro Tourism..Food was very tasty nd yummy..Best part of resort is Kayaking..One must visit the resort..🤩"
                </p>
                
                <div className="d-flex align-items-center mt-auto">
                  <img 
                    src={`https://i.pravatar.cc/150?img=${i + 10}`} 
                    className="rounded-circle me-3" 
                    alt="user" 
                    style={{ width: '50px', height: '50px' }} 
                  />
                  <div>
                    <h6 className="mb-0 fw-bold">Mahesh Bhosale</h6>
                    <small className="text-muted">Creative Director</small>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}